import { useEffect, useMemo, useState } from 'react';

const FALLBACK_POSTS = [
  {
    title: 'High-Income Tax Playbook 2026',
    excerpt: 'Playbook for stacking credits, depreciation, and advisor readiness without trigger flags.',
    slug: 'high-income-tax-playbook-2026',
    publishedAt: '2026-02-03',
    heroImage:
      'https://images.unsplash.com/photo-1460925895917-afdab827c52c?auto=format&fit=crop&w=1200&q=60',
  },
  {
    title: 'Webinar recap: Demystifying the IRS',
    excerpt: 'Ed Lyon breaks down red flags, compliance safe harbors, and how to forecast audit risk.',
    slug: 'webinar-recap-demystifying-irs',
    publishedAt: '2025-10-28',
    heroImage:
      'https://images.unsplash.com/photo-1454165205744-3b78555e5572?auto=format&fit=crop&w=1200&q=60',
  },
];

export const getStrapiBaseUrl = () => import.meta.env.VITE_STRAPI_API_URL?.replace(/\/$/, '');

export const getListUrl = () => {
  const base = getStrapiBaseUrl();
  if (!base) {
    return null;
  }

  return `${base}/api/blog-posts?populate[heroImage][fields][0]=url&pagination[pageSize]=10&sort[0]=publishedAt:desc`;
};

export const getStrapiHeaders = () => {
  const token = import.meta.env.VITE_STRAPI_API_TOKEN;
  if (!token) {
    return {};
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const normalizePost = (entry) => {
  const attrs = entry?.attributes || {};
  const hero = attrs?.heroImage?.data?.attributes;
  const baseUrl = getStrapiBaseUrl();

  const heroUrl = hero?.url
    ? hero.url.startsWith('http')
      ? hero.url
      : `${baseUrl || ''}${hero.url}`
    : null;

  return {
    title: attrs.title,
    excerpt: attrs.excerpt,
    slug: attrs.slug,
    publishedAt: attrs.publishedAt,
    heroImage: heroUrl,
    body: attrs.body,
  };
};

export function useStrapiPosts() {
  const [posts, setPosts] = useState(FALLBACK_POSTS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const url = useMemo(getListUrl, []);

  useEffect(() => {
    if (!url) {
      setLoading(false);
      return;
    }

    let isActive = true;
    setLoading(true);

    fetch(url, {
      headers: getStrapiHeaders(),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Could not load blog posts');
        }
        return res.json();
      })
      .then((data) => {
        if (!isActive) return;
        const entries = data.data || [];
        setPosts(entries.map(normalizePost));
      })
      .catch((fetchError) => {
        if (!isActive) return;
        console.error('Strapi posts error', fetchError);
        setError(fetchError);
      })
      .finally(() => {
        if (isActive) {
          setLoading(false);
        }
      });

    return () => {
      isActive = false;
    };
  }, [url]);

  return { posts, loading, error };
}
